import { client } from '../http';

async function updateOtsState(flowId, otsPhase, pageIndex) {
  const response = await client.put('/api/ots-il/state', {
    flowId,
    otsPhase,
    pageIndex: pageIndex.toString(),
  });
  return response.data;
}

async function getLatestOtsState() {
  const response = await client.get('/api/ots-il/state/latest');
  return response.data;
}

async function getOtsStateByFlowId(flowId) {
  const response = await client.get(`/api/ots-il/state/${flowId}`);
  return response.data;
}

export default {
  updateOtsState,
  getLatestOtsState,
  getOtsStateByFlowId,
};
